import {CustomerPaymentMethod} from './customer-payment-method';
import {ProvisioningParameter} from './provisioning-parameter';

export class Customer {
  name: string;
  companyLegalName: string;
  companyName: string;
  cpf: string;
  cnpj: string;
  birthDate: string;
  email: string;
  cellphone: string;
  zipcode: string;
  street: string;
  number: string;
  quarter: string;
  city: string;
  state: string;
  complement?: string;
  customerPaymentMethod: CustomerPaymentMethod;
  provisioningParameter: ProvisioningParameter;

  constructor(customerData?: Customer) {
    if (customerData) {
      Object.assign(this, customerData);
    } else {
      this.provisioningParameter = new ProvisioningParameter();
    }
  }

}
